
import { defineComponent, ref, watch } from "vue";

export default defineComponent({
  name: "CustomImageOrDefault",
  inheritAttrs: false,
  props: {
    category_key: {
      type: String,
      default: null,
    },
    view_type: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    const storageUrl = process.env.VUE_APP_STORAGE_URL;
    const customImageToShow = ref(false);
    const customImageSrc = ref("");

    function checkImageExists(url: string): Promise<boolean> {
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);
        img.src = url;
      });
    }

    async function updateCustomImage() {
      if (props.category_key && props.view_type) {
        const path = `/images/${props.view_type}/${props.category_key}.png`;
        const exists = await checkImageExists(path);
        if (exists) {
          customImageSrc.value = path;
          customImageToShow.value = true;
          return;
        }
      }
      customImageToShow.value = false;
    }

    watch(
      () => [props.category_key, props.view_type],
      () => {
        updateCustomImage();
      },
      { immediate: true },
    );

    return {
      storageUrl,
      customImageToShow,
      customImageSrc,
    };
  },
});
